<div fxLayout="row" fxLayoutAlign="space-between center">
    <div class="column">
      <h2 class="row">{{ "load-chainages.title" | translate }}</h2>
      <mat-paginator
      [length]="totalElements"
      [pageSizeOptions]="[5, 10, 25, 400]"
      [pageSize]="this.defaultPageSize"
      #paginator
      showFirstLastButtons
      (page)="this.handlePageEvent($event)"
    ></mat-paginator>
    </div>
    <div
      fxLayout="row"
      fxLayoutAlign="end center"
      class="searchbox"
    >
      <mat-form-field style="margin-right: 15px">
        <input
          matInput
          [placeholder]="placeholderSearch"
          #filter
        />
      </mat-form-field>
      <div *ngIf="topMenuIcons.length > 0">
        <button
          mat-raised-button
          *ngFor="let action of topMenuIcons"
          [routerLink]="action.routerLink"
          (click)="this[action.clickMethod]()"
          [disabled]="action.disabled ? action.disabled : false"
        >
          <mat-icon [title]="action.title"> {{ action.icon }} </mat-icon>
        </button>
      </div>
      <button
        mat-raised-button
        (click)="exporter.exportTable('xlsx', {fileName:exportPrefix+formatted})">
        <mat-icon
          [title]="titleExcel">download
        </mat-icon>
      </button>
    </div>
  </div>

  <div class="top-table-sticky-header">
  <mat-table
    [dataSource]="dataSource"
    [paginator]="paginator"
    [filter]="filter"
    class="mat-elevation-z8"
    matSort
    [matSortActive]="this.defaultSort.active"
    [matSortDirection]="this.defaultSort.direction"
    matSortDisableClear
    appNgMatTableQueryReflector
    matTableExporter
    #exporter="matTableExporter"
    [hiddenColumns]="[0]"
  >
    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->
    <ng-container matColumnDef="id">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle">
        id
      </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{ element.id }} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="chainage">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "load-chainage.chainage" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("load-chainage.chainage" | translate) + ":"'>
        {{ element.chainage | number : '.0-3'  }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "load-chainage.name" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("load-chainage.name" | translate) + ":"'>
        {{ element.name   }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="load">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "load-chainage.load" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("load-chainage.load" | translate) + ":"'>
        {{ element.load   }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="gravelStartPosition">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "load-chainage.gravelStartPosition" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("load-chainage.gravelStartPosition" | translate) + ":"'>
        {{ element.gravelStartPosition | number : '.0-3'   }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="loadPoint">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "load-chainage.load_point" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element; let i = index"
      class="m-card-title has_label_on_mobile"
      [attr.data-label]='("load-chainage.load_point" | translate) + ":"'>
        {{ element.loadPoint | number : '.0-3'  }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="kDistSoil">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "load-chainage.kDist-soil" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element; let i = index"
      class="m-card-title has_label_on_mobile"
      [attr.data-label]='("load-chainage.kDist-soil" | translate) + ":"'>
        {{ element.kDistSoil  }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="kSubSoil">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "load-chainage.kSub-soil" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element; let i = index"
      class="m-card-title has_label_on_mobile"
      [attr.data-label]='("load-chainage.kSub-soil" | translate) + ":"'>
      {{ element.kSubSoil | number : '.0-3'  }}
    </mat-cell>
  </ng-container>

      <ng-container matColumnDef="maxOverallTriangleLimit">
        <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
          {{ "load-chainage.max-overall-triangle-limit" | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element; let i = index"
        class="m-card-title has_label_on_mobile"
        [attr.data-label]='("load-chainage.max-overall-triangle-limit" | translate) + ":"'>
          {{ element.maxOverallTriangleLimit| number : '.0-3'  }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="gravelDiffOptimalThick">
        <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
          {{ "load-chainage.gravel-diff-optimal-thick" | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element; let i = index"
        class="m-card-title has_label_on_mobile"
        [attr.data-label]='("load-chainage.gravel-diff-optimal-thick" | translate) + ":"'>
          {{ element.gravelDiffOptimalThick | number : '.0-3'  }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="baseSurveyDiff">
        <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
          {{ "load-chainage.base-survey-diff" | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element; let i = index"
        class="m-card-title has_label_on_mobile"
        [attr.data-label]='("load-chainage.base-survey-diff" | translate) + ":"'>
          {{ element.baseSurveyDiff | number : '.0-3'  }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="bermHeightTarget">
        <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
          {{ "load-chainage.berm-height-target" | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element; let i = index"
        class="m-card-title has_label_on_mobile"
        [attr.data-label]='("load-chainage.berm-height-target" | translate) + ":"'>
          {{ element.bermHeightTarget | number : '.0-3'  }}
        </mat-cell>
      </ng-container>

    <ng-container matColumnDef="gravelSpacing">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "load-chainage.gravel-spacing" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element; let i = index"
      class="m-card-title has_label_on_mobile"
      [attr.data-label]='("load-chainage.gravel_spacing" | translate) + ":"'>
        {{ element.gravelSpacing | number : '.0-3'  }}
      </mat-cell>
    </ng-container>

   <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" class="one_actions"> </mat-header-cell>
      <mat-cell *matCellDef="let element" class="m-card-title one_actions">
        <div *ngIf="actions.length > 0">
          <button
            class="icon-button"
            *ngFor="let action of actions"
            [routerLink]="action.routerLink + element.id"
            (click)="this[action.clickMethod](element.id)"
            [state]="{ listdata: listIds }"

          >
            <mat-icon [title]="action.title"> {{ action.icon }} </mat-icon>
          </button>
        </div>
      </mat-cell>
    </ng-container>


    <mat-header-row *matHeaderRowDef="displayedColumns;sticky:true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
  </div>



